import React from 'react';
import styles from './Pills.module.scss';
import clsx from 'clsx';

const Pills = ({
  title = 'Sort by',
  showTitle = true,
  options = [],
  selected,
  onSelect,
  className,
}) => {
  return (
    <div className={clsx(styles.container, className)}>
      {showTitle && <div className={styles.title}>{title}</div>}
      <div className={styles.pillContainer}>
        {options.map((option) => (
          <div
            key={option.value}
            className={clsx(styles.pill, {
              [styles.active]: selected === option.value,
              [styles.inactive]: selected !== option.value,
            })}
            onClick={() => onSelect(option.value)}
          >
            <span className={styles.pillText}>{option.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pills;
